import { Row, Col, Form, Button, InputGroup } from 'react-bootstrap';
import { useState, useEffect, useCallback, useRef} from 'react';

//================================================================
// https://stackoverflow.com/questions/39913863/how-to-manually-trigger-click-event-in-reactjs

export default function FileInput ({onChange, disabled, fileName}){
  const inputRef = useRef(null);
  const handleCLick = useCallback(() => {
    inputRef.current?.click();
  });

  //----------------------------------------------------------------

  return(
    <>
      <Col className="col-4">
        <Form.Control
          type="file"
          style={{display : "none"}}
          onChange={onChange}
          ref={inputRef}
        />
        <Button
          size="sm"
          className="border-1 rounded d-block w-100 text-truncate"
          variant="outline-secondary"
          onClick={handleCLick}
          disabled={disabled}
        >
          Choose File
        </Button>
      </Col>
      <Col 
        className="col-7 d-block text-truncate"
        overflow-hidden
        span
      >
        {fileName || "No File Chosen"}
      </Col>
    </>
  );
}